export const POPUP_DATA = {
  ESTIMATED_YEARLY_TAX_SAVINGS: {
    TITLE: 'ESTIMATED_YEARLY_TAX_SAVINGS_COMPONENT_POPUP_TITLE',
    TEXT: 'ESTIMATED_YEARLY_TAX_SAVINGS_COMPONENT_POPUP_TEXT',
  },
  CHECKING_ACCOUNT: {
    TITLE: 'CHECKING_ACCOUNT_COMPONENT_POPUP_TITLE',
    TEXT: 'CHECKING_ACCOUNT_COMPONENT_POPUP_TEXT',
  },
} as const;

export const GO_TO_PRO_PATH = '/GoToPro';

export const ESTIMATED_YEARLY_TAX_SAVINGS_TEXT = 'ESTIMATED_YEARLY_TAX_SAVINGS_COMPONENT_TITLE';
export const CHECKING_ACCOUNT_TEXT = {
  CHECKING_ACCOUNT: 'CHECKING_ACCOUNT_COMPONENT_CHECKING_ACCOUNT',
  AVAILABLE_BALANCE: 'CHECKING_ACCOUNT_COMPONENT_AVAILABLE_BALANCE',
  TAX_BUCKET: 'CHECKING_ACCOUNT_COMPONENT_TAX_BUCKET',
  EMERGENCY_BUCKET: 'CHECKING_ACCOUNT_COMPONENT_EMERGENCY_BUCKET',
  OVERALL_BALANCE: 'CHECKING_ACCOUNT_COMPONENT_OVERALL_BALANCE',
  ADD_MONEY: 'CHECKING_ACCOUNT_COMPONENT_ADD_MONEY',
} as const;

export const POPUP_CLOSE_BTN_TEXT = 'Ok, Thanks';

export const CATEGORIZE_EXPENSES = {
  CLASSES: {
    CONTAINER: 'relative h-[33rem] bg-bw00 rounded-lg flex flex-col items-center',
    HR: 'font-metricMedium flex w-full py-[2px] px-[2px]',
    HEADING: 'h-[54px] w-full flex items-center pt-[7px] pl-[14px] text-bw08 gap-2 rounded-[6px] hover:bg-bw02',
    ICON: 'h-[1.5rem] w-[1.5rem]',
    STATE_ZERO: {
      CONTAINER: 'flex flex-col justify-center items-center h-full w-full text-center',
      TEXT: 'text-sm text-bw06',
      ICON: 'mb-8',
    },
    MASTER: {
      CONTAINER: 'flex flex-col justify-center items-center h-full w-full text-center',
      TEXT: 'text-sm text-bw06',
      ICON: 'mb-5',
      TEXT_1: 'font-metricMedium text-bw06',
      TEXT_2: 'font-metric text-sm text-bw06',
    },
    BUTTONS: {
      CONTAINER: 'flex gap-10 justify-center my-6',
      BTN: 'flex items-center justify-center h-[56px] w-[56px] cursor-pointer shadow-circle-md rounded-full border border-bw03 hover:shadow-circle-hover',
    },
    CARD: {
      WIDTH: '15rem',
      HEIGHT: '18rem',
      BG: 'bw-03',
      CONTAINER:
        'w-[206px] h-[243px] flex flex-col border border-bw03 items-center px-[15px] py-[14px] bg-bw00 rounded-lg',
      CATEGORY: 'text-bw06 text-xxs',
      DATE: 'text-bw07 mt-1 text-xxs',
      TRANSACTIONS_LEFT: 'my-4 text-sm',
      SPINNER: {
        COLOR: '#64C4CE',
        HEIGHT: '2rem',
        WIDTH: '2rem',
      },
    },
  },
  TEXT: {
    HEADING: 'CATEGORIZE_EXPENSES_COMPONENT_HEADER',
    STATE_ZERO: 'CATEGORIZE_EXPENSES_COMPONENT_STATE_ZERO',
    MASTER: {
      LINE1: 'CATEGORIZE_EXPENSES_COMPONENT_MASTER_LINE1',
      LINE2: 'CATEGORIZE_EXPENSES_COMPONENT_MASTER_LINE2',
      FOR_SCHEDULE: 'CATEGORIZE_EXPENSES_COMPONENT_MASTER_FOR_SCHEDULE',
    },
    TRANSACTIONS_LEFT: 'CATEGORIZE_EXPENSES_COMPONENT_TRANSACTIONS_LEFT',
    ONE_TRANSACTION_LEFT: 'CATEGORIZE_EXPENSES_COMPONENT_ONE_TRANSACTION_LEFT',
  },
} as const;

export const PROMOTION_TEXTS = {
  BTN_START_SAVING_TEXT: 'PROMOTION_BTN_START_SAVING_TEXT',
  EMERGENCY: {
    TITLE: 'PROMOTION_EMERGENCY_TITLE',
    TEXT: 'PROMOTION_EMERGENCY_TEXT',
  },
  SAVINGS: {
    TITLE_1: 'PROMOTION_SAVINGS_TITLE_1',
    TITLE_2: 'PROMOTION_SAVINGS_TITLE_2',
    TEXT: 'PROMOTION_SAVINGS_TEXT',
  },
  TAX: {
    TITLE: 'PROMOTION_TAX_TITLE',
    TEXT: 'PROMOTION_TAX_TEXT',
    BTN: 'PROMOTION_TAX_BTN',
  },
  EMERGENCY_TAX: {
    TITLE: 'PROMOTION_EMERGENCY_TAX_TITLE',
    SUB_TITLE_1: 'PROMOTION_EMERGENCY_TAX_SUB_TITLE_1',
    TEXT_1: 'PROMOTION_EMERGENCY_TAX_TEXT_1',
    BTN_TEXT_1: 'PROMOTION_EMERGENCY_TAX_BTN_TEXT_1',
    SUB_TITLE_2: 'PROMOTION_EMERGENCY_TAX_SUB_TITLE_2',
    TEXT_2: 'PROMOTION_EMERGENCY_TAX_TEXT_2',
    BTN_TEXT_2: 'PROMOTION_EMERGENCY_TAX_BTN_TEXT_2',
  },
  SAVINGS_TAX: {
    TITLE: 'PROMOTION_SAVINGS_TAX_TITLE',
    SUB_TITLE_1: 'PROMOTION_SAVINGS_TAX_SUB_TITLE_1',
    TEXT_1: 'PROMOTION_SAVINGS_TAX_TEXT_1',
    BTN_TEXT_1: 'PROMOTION_SAVINGS_TAX_BTN_TEXT_1',
    SUB_TITLE_2: 'PROMOTION_SAVINGS_TAX_SUB_TITLE_2',
    TEXT_2_1: 'PROMOTION_SAVINGS_TAX_TEXT_2_1',
    TEXT_2_2: 'PROMOTION_SAVINGS_TAX_TEXT_2_2',
    BTN_TEXT_2: 'PROMOTION_SAVINGS_TAX_BTN_TEXT_2',
  },
} as const;

export const COLUMNS_CLASSNAME = {
  COLUMN_1: 'w-[33%] pc-sm:w-[22.5rem] h-fit flex flex-col overflow-hidden',
  COLUMN_2: 'w-[33%] pc-sm:w-[22.5rem] h-fit flex flex-col gap-4 overflow-hidden',
  COLUMN_2_BASIC_USER: 'w-[66%] h-fit flex flex-col gap-4 overflow-hidden',
  COLUMN_3: 'w-[33%] pc-sm:w-[22.5rem] h-fit overflow-hidden',
};

export const SAVINGS_COMPONENT = {
  HEADER: 'SAVINGS_COMPONENT_HEADER',
  BUTTON_TEXT: 'SAVINGS_COMPONENT_BUTTON_TEXT',
} as const;

export const CONTAINER = 'CONTAINER';
export const TEXT = 'TEXT';
export const BUTTON = 'BUTTON';

export const UPDATE_YEARLY_TAX_SAVINGS = 2000;

export const WIDGET_STYLES = {
  BALANCE_UP: {
    ENROLLMENT: {
      WRAPPER: 'flex flex-col relative w-full h-[146px] bg-bw00 rounded-[8px] pt-[23px] pb-[22px] px-[24px]',
      HEADING: 'font-metricMedium text-bw08 text-[18px] mb-[4px] leading-[21px]',
      CONTENT:
        'font-metric text-[14px] text-bw06 mb-[6px] max-w-[190px] leading-[20px] pc-sm:whitespace-pre-line pc-md-lg:whitespace-normal',
      CTA: 'w-fit font-metric hover:border-b hover:border-b-action04 hover:text-action04 hover:cursor-pointer after:content-[">"] after:font-metric after:text-[14px] after:ml-[4px] after:text-action03 text-action03 leading-[20px] text-[14px]',
      ICON: 'max-w-[74px] hidden pc-sm:block pc-sm:w-[86px] absolute top-0 right-0 translate-x-[-10px] translate-y-[75px] pc-sm:translate-y-[40px]',
    },
    DASHBOARD: {
      WRAPPER: 'flex flex-col relative w-full h-[233px] bg-bw00 rounded-[8px] pb-[16px]',
      UPPER_WRAPPER: 'h-[54px] flex items-center mt-0.5 mx-0.5 hover:bg-bw02 rounded-[6px]',
      HEADING_WRAPPER: 'w-full flex items-center justify-between pt-[7px]',
      MAIN_ICON: 'ml-3 w-[32px] h-fit',
      HEADING: 'relative font-metricMedium text-[16px] text-bw08',
      ARROW_ICON_WRAPPER: 'w-[20px] h-[20px] ml-auto mr-[6px] rounded flex items-center justify-center hover:bg-bw03',
      ARROW_ICON: 'w-[6px] h-[10px] text-bw06',
      SEPARATOR_LINE: 'border-b border-bw06 opacity-30 w-full mt-0.5 mb-[12px]',
      PROGRESS_CHART_DONUT_WRAPPER: 'flex items-center mx-[40px]',
      FAKE_DONUT_WRAPPER:
        'w-[121px] min-w-[121px] min-h-[121px] h-[121px] rounded-[50%] bg-action01 flex items-center justify-center mx-[40px]',
      FAKE_DONUT_HEADING: 'font-metric text-bw07 text-[24px] text-center',
      CONTENT_AREA_WRAPPER: 'flex flex-col ml-[10px] pc-sm:ml-[28px]',
      NON_ELIGIBLE_CONTENT:
        'font-metric max-w-[115px] pc-sm:max-w-[140px] text-[12px] pc-sm:text-[14px] text-bw07 leading-normal mb-[16px]',
      CONTENT: 'font-metric text-[14px] text-bw05 leading-normal mb-[4px]',
      SUB_CONTENT: 'font-metric text-[20px] text-bw08',
      NON_ELIGIBLE_ICON: 'w-[16px] h-[16px] mr-[4px]',
      NON_ELIGIBLE_CTA:
        'flex justify-center items-center bg-action03 hover:bg-action04 w-[115px] pc-sm:w-[140px] h-[41px] rounded-umd text-bw00 font-metricMedium text-xxs',
    },
  },
  CATEGORIZATION: {
    WRAPPER: 'w-full h-fit flex flex-col items-center justify-center bg-bw00 rounded-lg pt-[2px] pb-[18px] relative',
    NAV_SWITCH_WRAPPER:
      'flex items-center gap-[6px] w-[280px] py-[4px] px-[2px] bg-bw02 border-[2px] border-bw03 rounded-[8px] mb-[34px]',
  },
};

export const CATEGORIZATION_SWITCH_ITEMS = [
  {
    id: 'EXPENSE',
    title: 'Expense',
    titleClassName: 'font-metric text-[12px] text-bw06',
    titleClassNameSelected: 'font-metric text-[12px] text-action03',
    wrapperClassName: 'cursor-pointer basis-1/2 text-center py-[4px] px-[4px]',
    wrapperClassNameSelected:
      'cursor-pointer basis-1/2 text-center bg-bw00 py-[4px] px-[4px] rounded-[6px] hover:shadow-light',
  },
  {
    id: 'INCOME',
    title: 'Income',
    titleClassName: 'font-metric text-[12px] text-bw06',
    titleClassNameSelected: 'font-metric text-[12px] text-action03',
    wrapperClassName: 'cursor-pointer basis-1/2 text-center py-[4px] px-[8px]',
    wrapperClassNameSelected:
      'cursor-pointer basis-1/2 text-center bg-bw00 py-[4px] px-[8px] rounded-[6px] hover:shadow-light',
  },
];
